export default __webpack_public_path__ + "static/media/1.eeca0ad1.jpg";